// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__xeGng","text":"styles_text__kw08L","count":"styles_count__0BzYp","slot":"styles_slot__LJxre","link":"styles_link__eXXVn"};